import React from 'react';
import styles from "./Card.module.scss";
export function Card(_ref) {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, title && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, title), /*#__PURE__*/React.createElement("div", null, children));
}